<template>
  <div>
    <!-- Hero Section -->
    <div class="hero-section position-relative">
      <div class="hero-overlay"></div>
      <div class="hero-image-container">
        <img src="@/assets/porto-service3.jpg" alt="Porto Service" class="hero-image">
      </div>
      <div class="container-fluid px-4 h-100">
        <div class="row h-100 align-items-center">
          <div class="col-12 text-center text-white position-relative">
            <h1 class="display-2 fw-bold mb-4">Nossos Serviços</h1>
            <p class="lead mb-4">Soluções completas em serviços navais</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Serviços Section -->
    <div class="py-6">
      <div class="container-fluid px-4">
        <div class="row g-4">
          <!-- Manutenção Naval -->
          <div class="col-lg-6">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-img-wrapper position-relative">
                <img src="@/assets/estaleiro.png" alt="Manutenção Naval" class="card-img-top service-img">
                <div class="card-img-overlay d-flex align-items-end">
                  <h3 class="text-white mb-0">Manutenção Naval</h3>
                </div>
              </div>
              <div class="card-body d-flex flex-column h-100 p-4">
                <p class="mb-4">Serviços especializados de manutenção preventiva e corretiva para embarcações, garantindo segurança e eficiência operacional.</p>
                <ul class="list-unstyled mb-5">
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Manutenção de motores</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Sistemas elétricos</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Estruturas navais</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Equipamentos de navegação</li>
                </ul>
                <div class="mt-auto">
                  <a href="#" class="btn btn-primary" @click.prevent="abrirOrcamento">Solicitar Orçamento</a>
                </div>
              </div>
            </div>
          </div>

          <!-- Engenharia Naval -->
          <div class="col-lg-6">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-img-wrapper position-relative">
                <img src="@/assets/engenharia-naval.png" alt="Engenharia Naval" class="card-img-top service-img">
                <div class="card-img-overlay d-flex align-items-end">
                  <h3 class="text-white mb-0">Engenharia Naval</h3>
                </div>
              </div>
              <div class="card-body d-flex flex-column h-100 p-4">
                <p class="mb-4">Projetos e soluções de engenharia naval, desde o design até a implementação, com foco em inovação e eficiência.</p>
                <ul class="list-unstyled mb-5">
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Projetos navais</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Consultoria técnica</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Análise estrutural</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Otimização de sistemas</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Análise de vibração e ruído</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Otimização do sistema propulsivo</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Diagnostico de maquinas com utilização de IA</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Eficiência energética aplicada a embarcações</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Projeto de sinalização e balizamento náutico</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Modelagem 3D</li>
                </ul>
                <div class="mt-auto">
                  <a href="#" class="btn btn-primary" @click.prevent="abrirOrcamento">Solicitar Orçamento</a>
                </div>
              </div>
            </div>
          </div>

          <!-- Inspeção e Certificação -->
          <div class="col-lg-6">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-img-wrapper position-relative">
                <img src="@/assets/inspecao.jpg" alt="Inspeção e Certificação" class="card-img-top service-img">
                <div class="card-img-overlay d-flex align-items-end">
                  <h3 class="text-white mb-0">Inspeção e Certificação</h3>
                </div>
              </div>
              <div class="card-body d-flex flex-column h-100 p-4">
                <p class="mb-4">Serviços completos de inspeção e certificação, garantindo conformidade com normas e regulamentações do setor naval.</p>
                <ul class="list-unstyled mb-5">
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Vistorias técnicas</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Certificações</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Laudos técnicos</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Documentação legal</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Inspeção pré vistoria para classificação de sistemas flutuantes</li>
                </ul>
                <div class="mt-auto">
                  <a href="#" class="btn btn-primary" @click.prevent="abrirOrcamento">Solicitar Orçamento</a>
                </div>
              </div>
            </div>
          </div>

          <!-- Consultoria Técnica -->
          <div class="col-lg-6">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-img-wrapper position-relative">
                <img src="@/assets/consultoria.jpg" alt="Consultoria Técnica" class="card-img-top service-img">
                <div class="card-img-overlay d-flex align-items-end">
                  <h3 class="text-white mb-0">Consultoria Técnica</h3>
                </div>
              </div>
              <div class="card-body d-flex flex-column h-100 p-4">
                <p class="mb-4">Assessoria especializada para otimização de processos e tomada de decisões no setor naval.</p>
                <ul class="list-unstyled mb-5">
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Análise de processos</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Gestão de projetos</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Estudos técnicos</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Soluções customizadas</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Gestão de frotas classificadas</li>
                  <li class="mb-2"><i class="bi bi-check2-circle text-primary me-2"></i>Estudos de viabilidade técnica e econômica de projetos navais</li>
                </ul>
                <div class="mt-auto">
                  <a href="#" class="btn btn-primary" @click.prevent="abrirOrcamento">Solicitar Orçamento</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA Section -->
    <div class="bg-primary text-white py-6">
      <div class="container-fluid px-4">
        <div class="row align-items-center">
          <div class="col-lg-8">
            <h2 class="display-4 mb-3">Precisa de nossos serviços?</h2>
            <p class="lead mb-lg-0">Entre em contato conosco e solicite um orçamento personalizado.</p>
          </div>
          <div class="col-lg-4 text-lg-end">
            <a href="#" class="btn btn-light btn-lg" @click.prevent="abrirOrcamento">Solicitar Orçamento</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Adicionar o componente do modal -->
    <OrcamentoModal />
  </div>
</template>

<script>
import OrcamentoModal from '@/components/OrcamentoModal.vue'
import { Modal } from 'bootstrap'

export default {
  name: 'Servicos',
  components: {
    OrcamentoModal
  },
  methods: {
    abrirOrcamento() {
      const modalElement = document.getElementById('orcamentoModal')
      const modal = new Modal(modalElement)
      modal.show()
    }
  }
}
</script>

<style scoped>
.hero-section {
  height: 60vh;
  min-height: 500px;
  overflow: hidden;
}

.hero-image-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: scale(1.1);
  animation: zoomEffect 20s infinite alternate ease-in-out;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0.4)
  );
  z-index: 1;
}

.container-fluid {
  position: relative;
  z-index: 2;
}

.card {
  transition: transform 0.3s ease;
  overflow: hidden;
  background-color: #fff;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}

.card-img-wrapper {
  height: 250px;
  overflow: hidden;
}

.service-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.card:hover .service-img {
  transform: scale(1.1);
}

.card-img-overlay {
  background: linear-gradient(
    transparent,
    rgba(0, 0, 0, 0.7)
  );
  transition: opacity 0.3s ease;
}

.card-img-overlay h3 {
  font-size: 1.5rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.btn {
  transition: transform 0.3s ease;
}

.btn:hover {
  transform: translateY(-2px);
}

@keyframes zoomEffect {
  from {
    transform: scale(1.1);
  }
  to {
    transform: scale(1.2);
  }
}

.py-6 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.bg-light {
  background-color: #fff !important;
}

.bg-primary {
  background-color: var(--primary-color) !important;
}

.btn-primary {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}

.btn-primary:hover {
  background-color: #003561 !important;
  border-color: #003561 !important;
}

.text-primary {
  color: var(--primary-color) !important;
}

/* Ajustes responsivos */
@media (max-width: 991.98px) {
  .hero-section {
    height: 50vh;
    min-height: 400px;
  }

  .display-2 {
    font-size: 3rem;
  }

  .display-4 {
    font-size: 2.5rem;
  }

  .card-img-wrapper {
    height: 200px;
  }
}

@media (max-width: 767.98px) {
  .hero-section {
    height: 40vh;
    min-height: 300px;
  }

  .hero-section h1 {
    font-size: 2.5rem;
  }

  .hero-section .lead {
    font-size: 1.1rem;
  }

  .py-6 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .card-img-wrapper {
    height: 180px;
  }

  .card-img-overlay h3 {
    font-size: 1.25rem;
  }
}
</style> 